<script setup lang="ts">
definePageMeta({
  title: 'pages.privacyPolicy.seo.title',
  description: 'pages.privacyPolicy.seo.description',
});
</script>

<template>
  <div>
    <LegalPrivacyPolicy />
  </div>
</template>
